var optionalBindings = ['annotation'];

function isEmptyValue(value) {
    return value === "" || value === null || angular.isUndefined(value) ||
        (angular.isArray(value) && value.length === 0) ||
        (angular.isObject(value) && Object.keys(value).length === 0);
}

module.directive('fakeField', function($parse, BasicOptions, Page, ModelConfig) {
    return {
        restrict: 'E',
        templateUrl: 'util/input/fakeField',
        transclude: true,
        require: '?^inlineForm',
        scope: {
            name: '@',
            value: '=',
        },
        link: function(scope, element, attrs, inlineForm) {
            var name = scope.name,
                highlightExpression;

            scope.type = angular.isDefined(attrs.type) ? attrs.type : 'text';

            if (scope.type === 'radios' ||
                    scope.type === 'checkboxes' ||
                    scope.type === 'select') {
                if (angular.isDefined(attrs.options)) {
                    scope.options = $parse(attrs.options)(scope.$parent);
                } else {
                    scope.options = ModelConfig.getOptions(name);
                }
            }


            if (BasicOptions[scope.type]) {
                scope.options = BasicOptions[scope.type];
                scope.type = 'radios';
            }


            scope.edit = function() {
                if (inlineForm) {
                    inlineForm.open(scope.name);
                }
            };


            if (angular.isDefined(attrs.label)) {
                attrs.$observe('label', function(label) {
                    scope.label = label;
                });
            }

            if (angular.isDefined(attrs.require) || angular.isUndefined(attrs.noRequire)) {
                highlightExpression = $parse(attrs.require || 'isEmpty');
                scope.$watch('value', function(value) {
                    element.toggleClass('empty', highlightExpression(scope.$parent, {
                        isEmpty: isEmptyValue(value),
                        value: value,
                    }));
                });
            }

            function updateOptionalBinding(key, value) {
                scope[key] = value;
            }

            var key;
            for (var i = 0; i < optionalBindings.length; i++) {
                key = optionalBindings[i];
                if (angular.isDefined(attrs[key])) {
                    attrs.$observe(key, updateOptionalBinding.bind(scope, key));
                }
            }

            element.addClass(scope.type);
        }
    };
});